import React from 'react';
import { useLocation, useHistory } from 'react-router-dom'
import utilService from '../util/utils.service';
// utils

function useQueryParams(options) {
  const { search } = useLocation();
  const history = useHistory();

  // get query params
  const queryParams = React.useMemo(() => utilService.queryStringToObject(search, options), [search]);

  // updates the query params
  function setQueryParams(queryObj) {
    history.push({
      search: utilService.createQueryString(queryObj)
    }); 
  };

  return { queryParams, setQueryParams };
};

export default useQueryParams;